<template>
    <div id="bottomLeft">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-bar"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">离线传感器</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />

                </div>
            </div>
            <div class="d-flex jc-center body-box">
                <dv-scroll-board :config="config" style="width:3.7rem;height:2.2rem;" />
            </div>
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
      };
    },
    mixins: [echartMixins],
    props: {
      config: {
        type: Object
      }
    },
    methods: {
    }
  };
</script>

<style lang="scss">
    #bottomLeft {
        padding: 0.3rem 0.2rem;
        height: 3rem;
        min-width: 1.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 3rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 1.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }
    }
</style>
